mutation updateGroupVisible($scenarioId: ID!, $originId: ID!, $groupId: ID!, $visible: Boolean!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    updateGroupVisible(groupId: $groupId, visible: $visible) {
      commited
      link {
        id
        code
      }
      validationErrors {
        ... on ExternalGroupValidation {
          allowed
          rejected_groups
          reason
          __typename
        }
        __typename
      }
    }
  }
}
